import { createSelector, StateContext } from '@ngxs/store';

import { EntityUpdateStrategy } from '../state/helpers';
import { IDocumentState } from './interfaces';

type ActionInstance = any;
type Document = any;

export interface IDocumentStateBase<Data> {
  new (updateStrategy: EntityUpdateStrategy): IDocumentStateBaseInstance<Data, any>;
  data: () => Data;
}

export interface IDocumentStateBaseInstance<Data, _Meta> {
  save: (ctx: StateContext<IDocumentState<any>>, action: ActionInstance, data: Data) => void;
  markAsLoading: (ctx: StateContext<IDocumentState<any>>) => void;
  setError: (ctx: StateContext<IDocumentState<any>>, error: any) => void;
}

export abstract class DocumentStateBase<Data> implements IDocumentStateBaseInstance<any, any> {
  public static get data(): (...args: any) => Document {
    return createSelector([this], (repo: IDocumentState<any>) => repo.data);
  }

  protected constructor(
    protected updateStrategy: (oldEntity: Document, newEntity: Document) => Document,
  ) {}

  public save(ctx: StateContext<IDocumentState<any>>, action: ActionInstance, data: Data): void {
    const state = ctx.getState();

    ctx.patchState({
      data: this.updateStrategy(state.data, data),
      lastUpdated: Date.now(),
      loading: false,
      error: null,
    });
  }

  public markAsLoading(ctx: StateContext<IDocumentState<any>>): void {
    ctx.patchState({ loading: true });
  }

  public setError(ctx: StateContext<IDocumentState<any>>, error: any): void {
    ctx.patchState({
      loading: false,
      error,
    });
  }
}

export const DocumentState = <T>(): IDocumentStateBase<T> => <any>DocumentStateBase;
